import styled from "styled-components";

export const ContentNewComand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  color: ${props => props.$textColor || '#ff6200'};
  cursor: pointer;

  &:hover {
    color: ${props => props.$hoverColor || '#d25100'};
  }

  .contentCancelAction {
    width: 23px;
    height: 23px;
    min-width: 23px;
    min-height: 23px;
    background-color: white;
    transition: ease-in 0.1s;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f1f5f9;
  }

  .contentCancelAction:hover {
    transition: ease-in 0.1s;
    background-color: #d2d6db;
  }
`

export const ContentCards = styled.div`
  display: flex;
  gap: 1.5rem;
  overflow: auto;
  padding: 0.2rem 1rem 1rem 1rem;

  &::-webkit-scrollbar {
    width: 2px!important;
    height: 3px!important;
  }

  &::-webkit-scrollbar-track {
    background: whitesmoke!important;
    border-radius: 8px!important;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ff6200!important;
    border-radius: 8px!important;
  }
`

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 8px;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 0 2px 1px #dae2f0;
  min-width: ${props => props.$minWidth || '140px'};
  max-width: ${props => props.$maxWidth || '140px'};
  cursor: pointer;
  transition: ease 0.1s;
  flex: 1;

  &:hover {
    transition: ease 0.1s;

    ${props => !props.$active && `
      box-shadow: 0 0 0 1.5px #bccfea!important;
      transition: ease 0.1s;
    `}
  }

  ${props => props.$active && `
      box-shadow: 0 0 0 2px #ff6200;
      background-color: rgb(255 247 237 / 0.5);
      transition: ease 0.1s;
  ` }

  .title {
    color: ${props => props.$active ? '#f97316' : 'rgb(148, 163, 184)'};
    font-weight: ${props => props.$active ? '700' : props.$titleWeight || '600'};
    font-size: var(--font-size-section-title);
  }

  .subtitle {
    font-weight: bold;
    font-size: var(--font-size-highlight);
  }

  .totalItems {
    color: rgb(148, 163, 184)!important;
    font-weight: 400;
    font-size: var(--font-size-body);
    margin-top: 0.3rem
  }
`
